// src/components/common/actionBeat/foldingLinkStyle.js
//
// KAN-1078: a confirm's third-choice text link folds away with Cancel when the
// write beat starts (the primary then owns the whole row). Pure style helper.

export function foldingLinkStyle(beatActive, reduced) {
  return {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    maxHeight: beatActive ? 0 : 64,
    opacity: beatActive ? 0 : 1,
    pointerEvents: beatActive ? 'none' : undefined,
    transition: reduced ? 'none' : 'max-height 260ms ease, opacity 200ms ease',
  };
}
